const objectSize = (object: object) => Object.keys(object).length

export default objectSize
